import { render, staticRenderFns } from "./RequestStatusPie.vue?vue&type=template&id=15e620b8&scoped=true"
import script from "./RequestStatusPie.vue?vue&type=script&lang=js"
export * from "./RequestStatusPie.vue?vue&type=script&lang=js"
import style0 from "./RequestStatusPie.vue?vue&type=style&index=0&id=15e620b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e620b8",
  null
  
)

export default component.exports